import { apiFetch } from './client.js'

export function listUsers() {
  return apiFetch('/users')
}

export function createUser(body) {
  return apiFetch('/users', {
    method: 'POST',
    body,
  })
}

export function updateUserRole(userId, role) {
  return apiFetch(`/users/${userId}`, {
    method: 'PATCH',
    body: { role },
  })
}

export function deactivateUser(userId) {
  return apiFetch(`/users/${userId}`, { method: 'DELETE' })
}
